/**
 * H2C Backend
 * An ASP.NET Core Web API for managing H2C User 
 *
 * The version of the OpenAPI document: V40:2026_08_27_13_13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TH2CompanyDTO { 
    company_id?: number;
    company_insert_timstamp?: string | null;
    company_update_timstamp?: string | null;
    company_name?: string | null;
    company_city?: string | null;
    company_street?: string | null;
    company_street_number?: string | null;
    company_zip_code?: string | null;
    company_country_id?: number;
    company_insert_time?: string | null;
    company_facility_count?: number | null;
    company_consumer_facility_count?: number | null;
    company_producer_facility_count?: number | null;
}

